import { Button } from "components/Button/Button";
import { defaultButtonProps, inlineButtonProps } from "components/Button/constants";
import PropTypes from "prop-types";

const ActionButton = ({ action, href, label, icon, tiny, disabled, loading, image }) => (
    <Button
        onClick={href ? undefined : action}
        href={href}
        icon={icon}
        size={tiny ? inlineButtonProps.size : defaultButtonProps.size}
        variation={tiny ? inlineButtonProps.variation : defaultButtonProps.variation}
        label={tiny ? null : label}
        title={tiny ? label : null}
        disabled={disabled}
        loading={loading}
        image={image}
    />
);

ActionButton.defaultProps = {
    tiny: false,
    disabled: false,
    loading: false,
};

ActionButton.propTypes = {
    action: PropTypes.func,
    href: PropTypes.string,
    label: PropTypes.string.isRequired,
    icon: PropTypes.elementType,
    image: PropTypes.any,
    tiny: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
};

export default ActionButton;
